import { render, staticRenderFns } from "./TransacaoOnline.vue?vue&type=template&id=450bf450"
import script from "./TransacaoOnline.vue?vue&type=script&lang=js"
export * from "./TransacaoOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports